import React from "react";

import {
  Tooltip as MuiTooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const WideWhiteTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <MuiTooltip {...props} classes={{ popper: className }}>
      <span>{props.children}</span>
    </MuiTooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    padding: "15px !important",
    borderRadius: "5px",
    minWidth: "414px !important",
    boxShadow: theme.igShadows.low,
  },
}));
